/**
The main entry point for OV Outdoors.
Referenced by page.outdoors.liquid templates.
* */
import React from 'react';
import ReactDOM from 'react-dom';
import PageHomepage from './apps/pages/homepage';
import OVApp from './utils/OVContext'; // Live OV Outdoors 2023 LP ID

import { jsx as _jsx } from "react/jsx-runtime";
var defaultId = 'SG9tZXBhZ2VOb2RlOjQwNQ=='; // Get homepage ID from Shopify page content

var pageElement = document.getElementById('outdoors');
var pageContentId = pageElement.getAttribute('data-homepage-id');
var homepageId = pageContentId ? pageContentId : defaultId;
ReactDOM.render( /*#__PURE__*/_jsx(OVApp, {
  children: /*#__PURE__*/_jsx(PageHomepage, {
    id: homepageId
  })
}), document.getElementById('outdoors'));